import React, { useEffect, useState } from 'react';
import { format, parseISO } from 'date-fns';
import type { HistoryRow } from '../../types/hr';
import { Button } from '../ui/Button';
import { Modal } from '../ui/Modal';
import type { HistoryColumn } from './HistoryCard';
interface AddEntryModalProps {
  open: boolean;
  title: string;
  columns: HistoryColumn[];
  onClose: () => void;
  onSave: (row: HistoryRow) => void;
}
function isDateColumn(c: HistoryColumn): boolean {
  return c.key === 'date' || /date|vesting start/i.test(c.label);
}
export function AddEntryModal({
  open,
  title,
  columns,
  onClose,
  onSave
}: AddEntryModalProps) {
  const [values, setValues] = useState<Record<string, string>>({});
  const [error, setError] = useState('');
  useEffect(() => {
    if (open) {
      setValues({});
      setError('');
    }
  }, [open]);
  const first = columns[0];
  const save = () => {
    if (!first || !values[first.key]?.trim()) {
      setError(`${first?.label ?? 'First field'} is required`);
      return;
    }
    const row: HistoryRow = {};
    columns.forEach(c => {
      const v = (values[c.key] ?? '').trim();
      row[c.key] = v && isDateColumn(c) ? format(parseISO(v), 'MMM d, yyyy') : v;
    });
    onSave(row);
  };
  return <Modal open={open} onClose={onClose} title={`Add ${title} entry`} description="New entries appear at the top of the history table." footer={<>
          <Button onClick={onClose} data-id="element-249" data-mp="3q34beqigto1">Cancel</Button>
          <Button variant="primary" onClick={save} data-id="element-250" data-mp="8oebtitc2s33">
            Save entry
          </Button>
        </>} data-id="element-248" data-mp="3784gg030gqk0">
      <div className="grid max-h-[55vh] grid-cols-1 gap-4 overflow-y-auto pr-1 sm:grid-cols-2" data-id="element-251" data-mp="3q5xlb7x73ak1">
        {columns.map((c, i) => {
        const id = `entry-${c.key}`;
        return <label key={c.key} htmlFor={id} className="block text-xs font-medium text-slate-600" data-id="element-252" data-mp="mnxdbsrn356f" data-mpi={i}>
              {c.label}
              {i === 0 && <span className="text-rose-500" data-id="element-253" data-mp="rgqcm14c9lb4"> *</span>}
              <input id={id} type={isDateColumn(c) ? 'date' : 'text'} value={values[c.key] ?? ''} onChange={e => {
            setValues(prev => ({
              ...prev,
              [c.key]: e.target.value
            }));
            setError('');
          }} className={`mt-1.5 h-11 w-full rounded-xl border-0 bg-white px-3.5 text-sm text-navy ring-1 ring-inset focus:outline-none focus:ring-2 focus:ring-azure ${i === 0 && error ? 'ring-rose-300' : 'ring-slate-200'}`} data-id="element-254" data-mp="11bnwgngz3d65" />
            </label>;
      })}
      </div>
      {error && <p className="mt-3 text-xs text-rose-600" data-id="element-255" data-mp="8mqbudpah4a8">{error}</p>}
    </Modal>;
}